<template>
  <div class="share-btn" :class="{ active: active }" @click="active = !active">
    <img src="../assets/images/icon-share.svg" width="45" />
    <div class="share-items" v-if="site">
      <ShareNetwork v-for="network in networks" :title="site.websiteName || shareUrl" :network="network.network" :key="network.network" :style="{ backgroundColor: network.color }" :url="shareUrl">
        <i :class="network.icon"></i>
      </ShareNetwork>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ShareBtn',
  props: ['shareUrl'],
  data() {
    return {
      active: false,
      url: '',
      networks: [
        {
          network: 'facebook',
          name: 'Facebook',
          icon: 'fab fah fa-lg fa-facebook-f',
          color: '#1877f2',
        },
        {
          network: 'twitter',
          name: 'Twitter',
          icon: 'fab fah fa-lg fa-twitter',
          color: '#1da1f2',
        },
        {
          network: 'line',
          name: 'Line',
          icon: 'fab fah fa-lg fa-line',
          color: '#00c300',
        },
        {
          network: 'weibo',
          name: 'Weibo',
          icon: 'fab fah fa-lg fa-weibo',
          color: '#e9152d',
        },
        {
          network: 'whatsapp',
          name: 'Whatsapp',
          icon: 'fab fah fa-lg fa-whatsapp',
          color: '#25d366',
        },
      ],
    }
  },
  computed: {
    ...mapState(['site']),
  },
  methods: {
    // 分享
    shareToggle: function (event) {
      event.target.classList.toggle('active')
    },
  },
}
</script>

<style scoped lang="sass"></style>
